import { userIsDistributor, userIsInquirer, userIsPurchaser } from "~/domains/user/utils/roles";

export const userCanSetMyCompanyOrders = () => (userIsDistributor() || userIsPurchaser()) && !userIsInquirer();
export const userCanSetMyCompanyQuotes = () => userIsDistributor() || userIsPurchaser() || userIsInquirer();
export const userCanSeeMyCompanySettings = () => userCanSetMyCompanyOrders() || userCanSetMyCompanyQuotes();
